import React, { useState, useEffect } from 'react';
import { Table, Spin, Button, Row, Col, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { getExpenditureListingData } from '../../../../Expenditures/ducks/actions.js';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

const antIcon = <LoadingOutlined spin />;

export default (props) => {
  const { currentStep, setCurrentStep, startDate, endDate, reportId } = props;
  const [loading, setLoading] = useState(false);
  const expenditureListData = useSelector((state) => state.expenditure.expenditureListData);
  const dispatch = useDispatch();
  const history = useHistory();
  const urlID = history.location.pathname.split('/')[3];
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  useEffect(() => {
    dispatch(getExpenditureListingData(startDate, endDate));
  }, [startDate, endDate]);

  const listColumns = [
    {
      title: 'Date',
      dataIndex: 'date',
      render: (text) => moment(text).format('MM-DD-YYYY'),
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
    },
    {
      title: 'Expenditure Type',
      dataIndex: 'type',
      render: (text) => <span className="text-capitalize">{text ? text.replace(/_/g, ' ') : '-'}</span>,
    },
    {
      title: 'Payee',
      dataIndex: 'payee',
    },
    {
      title: 'Form',
      dataIndex: 'payment_type',
      render: (text) => <span className="text-capitalize">{text ? text.replace(/_/g, ' ') : '-'}</span>,
    },
    {
      title: 'Account Code',
      dataIndex: 'bankaccount',
    },
  ];

  const moveToNextStep = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setCurrentStep(currentStep + 1);
    }, 1200);
  };

  const fetchData = (params = {}, fromDate = 'null', toDate = 'null') => {
    fetch(``).then(({ results }) => {
      setPagination({
        ...params.pagination,
      });
    });
  };

  useEffect(() => {
    fetchData({
      pagination,
    });
  }, []);

  const handleTableChange = (newPagination, filters) => {
    fetchData({
      pagination: newPagination,
      ...filters,
    });
  };

  useEffect(() => {
    setLoading(true);
    if (expenditureListData) {
      setTimeout(() => {
        setLoading(false);
      }, 1500);
    }
  }, [expenditureListData]);

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <Table
        columns={listColumns}
        dataSource={expenditureListData}
        pagination={pagination}
        onChange={handleTableChange}
      />
      <Row align="middle" justify="center" gutter={[20, 20]}>
        <Col>
          <Button
            type="primary"
            onClick={() => setCurrentStep(currentStep - 1)}
            htmlType="button"
            className="font-gilroy white-btn"
            size="large"
          >
            Back
          </Button>
        </Col>

        <Col>
          <Button
            type="primary"
            onClick={() => moveToNextStep()}
            htmlType="button"
            className="font-gilroy"
            size="large"
          >
            Continue
          </Button>
        </Col>
      </Row>
    </Spin>
  );
};
